/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Discounts {
    'use strict';

    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import DiscountEntityTypeEnum = Meevo.Model.DiscountEntityTypeEnum;
    import DiscountEntityGranularityTypeEnum = Meevo.Model.DiscountEntityGranularityTypeEnum;
    import DiscountBuyGetTypeEnum = Meevo.Model.DiscountBuyGetTypeEnum;
    import IManufacturer = Meevo.Model.Manufacturer;
    import IBusyService = Meevo.Components.Busy.IBusyService;
    import IDiscount = Meevo.Model.IDiscount;
    import DiscountBasedOnEnum = Meevo.Model.DiscountBasedOnEnum;

    // interface for selecting appropriate field in items' mover
    interface IMoverFields {
        entityType: string;
        entityGranularityType: string;
        manufacturer: string;
        services: string;
        productVariants: string;
        packageTypes: string;
        memberships: string;
        giftCardTypes: string;
        fees: string | number;
    }

    interface IproductCriteria {
        includeBundles?: boolean;
        includeProducts?: boolean;
        variantObjectState?: Model.ObjectStateEnum[];
        ManufacturerIds?: Guid[];
        ProductCategoryIds?: string[];
    }

    export interface IProductFilter {
        manufacturers: any[],
        productCategories: any[],
    }

    export interface IServiceFilter {
        serviceCategories: any[],
    }

    interface IServiceCriteria {
        ServiceCategoryIds?: string[];
        includeActive: boolean,
        maintenanceMode: boolean,
        includeInactive: boolean,
        includeDeleted: boolean
    }

    enum DiscountProductSortBy {
        manufacturer = 1,
        productCategories
    }

    /**
     * Main Section of ServiceCategory
     */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IDiscount> {
        public model: IDiscount;

        public discountTypes: Object;
        public discountTypesList: Array<any> = [];
        public entityTypes: Object;
        public entityTypesRedeem: Object;
        public redeemableLimitTypes: Object;
        public baseOnTypes: Object;

        public barCodeRegExp: RegExp = new RegExp('^[a-z0-9]+$', 'i');

        public entityGranularityTypeList: Object = {};
        public buyEntityGranularityTypeList: Object = {};

        public manufacturers: Array<IManufacturer> = [];

        private busyService: IBusyService;
        private modalService: Meevo.Components.Modal.IModalService;
        public isAmountInPercents: boolean = false;
        public employeeFilterCriteria: any = { showEmployeesOnly: true };
        public productCriteria: IproductCriteria;
        public productFilter: IProductFilter;
        public serviceCriteria: IServiceCriteria;
        public serviceFilter: IServiceFilter;
        public sortBy: any[];
        productGetSortBy: DiscountProductSortBy = DiscountProductSortBy.manufacturer;
        productBuySortBy: DiscountProductSortBy = DiscountProductSortBy.manufacturer;

        constructor(sectionId: number,
                    displayNameContentKey: string,
                    template: string,
                    isPrimarySection: boolean,
                    handlesOwnCrud: boolean,
                    baseEndpoint: string,
                    sectionEndpoint: string,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    discountsService: Meevo.Plugins.Discounts.IDiscountsService,
                    busyService: Meevo.Components.Busy.IBusyService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    noun: Meevo.Model.NounEnum,
                    modalService: Meevo.Components.Modal.IModalService,
                    sectionSecurityKey?: string) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.discountTypes = discountsService.discountTypes;
            this.entityTypes = discountsService.entityTypes;
            this.entityTypesRedeem = _(this.entityTypes).filter((entity: any) => 
                entity.id === Meevo.Model.DiscountEntityTypeEnum.ProductService ||
                entity.id === Meevo.Model.DiscountEntityTypeEnum.Service ||
                entity.id === Meevo.Model.DiscountEntityTypeEnum.Product ||
                entity.id === Model.DiscountEntityTypeEnum.RebookedAppointments
            );
            this.redeemableLimitTypes = discountsService.redeemableLimitTypes;
            this.baseOnTypes = discountsService.baseOnTypes;
            this.busyService = busyService;
            this.modalService = modalService;

            this.setInitialValues();

            for (var i in this.discountTypes) {
                this.discountTypesList.push(this.discountTypes[i]);
            }

            this.sortBy = [
                { label: 'LABEL_MANUFACTURER', value: DiscountProductSortBy.manufacturer },
                { label: 'LABEL_INPUT_PRODUCT_CATEGORY', value: DiscountProductSortBy.productCategories }
            ];
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.busyService.start();
            this.dataService.getTemplate(this.baseEndpoint)
                .then((data: IDiscount) => {
                    this.model = data;
                    this.model.isNonMembershipClientDiscount = true;
                    this.model.isMembershipClientDiscount = true;
                    this.model.discountAmount = 0;
                    this.model.bogoBasedOnTypeEnum = DiscountBasedOnEnum.Quantity;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        changeDiscount(): void {
            if (this.model.isEmployeeExclusive) {
                this.model.isNonMembershipClientDiscount = false;
                this.model.isMembershipClientDiscount = false;
            } else {
                this.model.isNonMembershipClientDiscount = true;
                this.model.isMembershipClientDiscount = true;
            }
        }

        /**
         * Set initial values
         */
        setInitialValues(): void {
            this.entityGranularityTypeList[DiscountEntityTypeEnum.Service] = {
                1: { 'displayName': 'LABEL_ALL_SERVICES', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_SERVICES', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.Product] = {
                1: { 'displayName': 'LABEL_ALL_PRODUCTS', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_PRODUCTS', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.Package] = {
                1: { 'displayName': 'LABEL_ALL_PACKAGES', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_PACKAGE', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.ProductService] = {};
            this.entityGranularityTypeList[DiscountEntityTypeEnum.Membership] = {
                1: { 'displayName': 'LABEL_ALL_MEMBERSHIPS', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_MEMBERSHIP', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.GiftCard] = {
                1: { 'displayName': 'LABEL_ALL_GIFT_CARD_TYPE', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_GIFT_CARD', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.Fees] = {
                1: { 'displayName': 'LABEL_ALL_FEES', 'id': DiscountEntityGranularityTypeEnum.All },
                2: {
                    'displayName': 'LABEL_ALL_MEMBERSHIP_FEES',
                    'id': DiscountEntityGranularityTypeEnum.AllMembershipFees
                },
                3: { 'displayName': 'LABEL_SPECIFIC_FEES', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };
            this.entityGranularityTypeList[DiscountEntityTypeEnum.RebookedAppointments] = {
                1: { 'displayName': 'LABEL_ALL_SERVICES', 'id': DiscountEntityGranularityTypeEnum.All },
                2: { 'displayName': 'LABEL_SPECIFIC_SERVICES', 'id': DiscountEntityGranularityTypeEnum.Specific }
            };

            this.dataService.getCount('swapGroup', {})
                .then((results: any) => {
                    if (results > 0) {
                        this.entityGranularityTypeList[DiscountEntityTypeEnum.Fees] = {
                            1: { 'displayName': 'LABEL_ALL_FEES', 'id': DiscountEntityGranularityTypeEnum.All },
                            2: {
                                'displayName': 'LABEL_ALL_MEMBERSHIP_FEES',
                                'id': DiscountEntityGranularityTypeEnum.AllMembershipFees
                            },
                            3: {
                                'displayName': 'LABEL_ALL_PACKAGE_SWAP_UPGRADE_FEES',
                                'id': DiscountEntityGranularityTypeEnum.AllPackageSwapUpgradeFees
                            },
                            4: {
                                'displayName': 'LABEL_SPECIFIC_FEES',
                                'id': DiscountEntityGranularityTypeEnum.Specific
                            }
                        };
                    }
                });

            // create copy for "Buy One/Get One" functionality
            this.buyEntityGranularityTypeList = angular.copy(this.entityGranularityTypeList);

            this.productFilter = {
                manufacturers: [],
                productCategories: [],
            };
            this.productCriteria = {
                includeBundles: true,
                includeProducts: true,
                variantObjectState: [Model.ObjectStateEnum.Active, Model.ObjectStateEnum.Inactive],
                ManufacturerIds: [],
                ProductCategoryIds: [],
            };

            this.serviceFilter = {
                serviceCategories: [],
            };
            this.serviceCriteria = {
                ServiceCategoryIds: [],
                includeActive: true,
                maintenanceMode: true,
                includeInactive: false,
                includeDeleted: false
            };
        }

        /**
         * User selects some entity type with selectbox
         * @param {DiscountBuyGetTypeEnum} discountBuyGetType
         */
        entityTypeChanged(discountBuyGetType: DiscountBuyGetTypeEnum = DiscountBuyGetTypeEnum.Get): void {
            let entityGranularityType: string;

            // select appropriate model name
            if (discountBuyGetType === DiscountBuyGetTypeEnum.Get) {
                this.discountEntityAllSelected = true;
            } else if (discountBuyGetType === DiscountBuyGetTypeEnum.Buy) {
                this.buyEntityAllSelected = true;
            }
        }

        public get discountEntityAllSelected()
        {
            return this.model.discountEntityGranularityTypeEnum === DiscountEntityGranularityTypeEnum.All;
        }

        public set discountEntityAllSelected(value)
        {
            this.model.discountEntityGranularityTypeEnum = value ? DiscountEntityGranularityTypeEnum.All : DiscountEntityGranularityTypeEnum.Specific;
        }

        public get buyEntityAllSelected()
        {
            return this.model.buy_EntityGranularityTypeEnum === DiscountEntityGranularityTypeEnum.All;
        }

        public set buyEntityAllSelected(value) {
            this.model.buy_EntityGranularityTypeEnum = value ? DiscountEntityGranularityTypeEnum.All : DiscountEntityGranularityTypeEnum.Specific;
        }

        public getBuyEntityTypes() {
            if (this.model && this.model.isAllowRedeemBuyGet) {
                return this.entityTypesRedeem;
            }

            return this.entityTypes;
        }

        /**
         * Entity granularity type changed
         * @param {DiscountBuyGetTypeEnum} discountBuyGetType
         */
        entityGranTypeChanged(discountBuyGetType: DiscountBuyGetTypeEnum = DiscountBuyGetTypeEnum.Get): void {
            let entityGranularityType: string,
                manufacturerId: string;

            // select appropriate models' names for entityGranularityType and manufacturerId
            if (discountBuyGetType === DiscountBuyGetTypeEnum.Get) {
                entityGranularityType = 'discountEntityGranularityTypeEnum';
                manufacturerId = 'discountManufacturer_TId';

            } else if (discountBuyGetType === DiscountBuyGetTypeEnum.Buy) {
                entityGranularityType = 'buy_EntityGranularityTypeEnum';
                manufacturerId = 'buy_Manufacturer_TId';
            }

            if (this.model[entityGranularityType] === DiscountEntityGranularityTypeEnum.SpecificManufacturer) {
                this.busyService.start();
                this.dataService.getListPaged('Manufacturer', {})
                    .then((manufacturers: Array<IManufacturer> | any) => {
                        this.manufacturers = manufacturers;
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            } else {
                this.model[manufacturerId] = "";
            }
        }

        /**
         * Discount type changed
         */
        discountTypeChanged(): void {
            let discountType: DiscountTypeEnum;

            if (this.model.discountTypeEnum === DiscountTypeEnum.BuyGet) {
                this.model.isBuyGet = true;
                this.model.requiredQuantity = 0;
                if (this.model.buy_Quantity <= 0) {
                    this.model.buy_Quantity = 1;
                }
                if (this.model.get_Quantity <= 0) {
                    this.model.get_Quantity = 1;
                }
                discountType = this.model.discountTypeEnumGet;
            } else {
                discountType = this.model.discountTypeEnum;
                this.model.isBuyGet = false;
                if (this.model.requiredQuantity <= 0) {
                    this.model.requiredQuantity = 1;
                }
                this.model.buy_Quantity = 0;
                this.model.get_Quantity = 0;
            }

            if (discountType === DiscountTypeEnum.PercentOff && !this.isAmountInPercents) {
                let percentOff = this.model.discountAmount / 100;

                this.model.discountAmount = percentOff > 1 ? 1 : percentOff;

                this.isAmountInPercents = true;
            } else if ((discountType === DiscountTypeEnum.AmountOff || discountType === DiscountTypeEnum.SpecialPrice) && this.isAmountInPercents) {
                this.model.discountAmount *= 100;

                this.isAmountInPercents = false;
            }

            // user will need to re-select "Spread Discount" whenever changing discount type
            this.model.isSpread = false;

            console.log('discount chosen -->', discountType);
        }

        private convertIdsToObjects(modelProp, modelIdsProp, entityType, discountEntityGranularityProp, ...entityTypes)
        {
            this.model[modelProp] = entityTypes.indexOf(this.model[entityType]) !== -1 && this.model[discountEntityGranularityProp] === DiscountEntityGranularityTypeEnum.Specific
                ? this.model[modelIdsProp].map(id => {
                    return { id: id };
                })
                : [];
        }
        /**
         * Prepare model for saving
         */
        public preSave(): void {
            if (this.model.isBuyGet) {
                this.model.discountTypeEnum = this.model.discountTypeEnumGet;
                this.model.isSpread = false;

                if (this.model.bogoBasedOnTypeEnum == DiscountBasedOnEnum.Amount) {
                    this.model.isAllowRedeemBuyGet = false;
                }
            }

            this.convertIdsToObjects("services", "serviceIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.Service, DiscountEntityTypeEnum.RebookedAppointments);
            this.convertIdsToObjects("productVariants", "productVariantIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.Product);
            this.convertIdsToObjects("packageTypes", "packageTypeIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.Package);
            this.convertIdsToObjects("memberships", "membershipIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.Membership);
            this.convertIdsToObjects("giftCardTypes", "giftCardTypeIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.GiftCard);
            this.convertIdsToObjects("fees", "feeIds", "discountEntityTypeEnum", "discountEntityGranularityTypeEnum", DiscountEntityTypeEnum.Fees);
            this.convertIdsToObjects("buy_Services", "buy_ServiceIds", "buy_EntityTypeEnum", "buy_EntityGranularityTypeEnum", DiscountEntityTypeEnum.Service, DiscountEntityTypeEnum.RebookedAppointments);
            this.convertIdsToObjects("buy_ProductVariants", "buy_ProductVariantIds", "buy_EntityTypeEnum", "buy_EntityGranularityTypeEnum", DiscountEntityTypeEnum.Product);
            this.convertIdsToObjects("buy_PackageTypes", "buy_PackageTypeIds", "buy_EntityTypeEnum", "buy_EntityGranularityTypeEnum", DiscountEntityTypeEnum.Package);
            this.convertIdsToObjects("buy_Memberships", "buy_MembershipIds", "buy_EntityTypeEnum", "buy_EntityGranularityTypeEnum", DiscountEntityTypeEnum.Membership);
            this.convertIdsToObjects("buy_GiftCardTypes", "buy_GiftCardTypeIds", "buy_EntityTypeEnum", "buy_EntityGranularityTypeEnum", DiscountEntityTypeEnum.GiftCard);

            if (!this.model.barCode) {
                this.model.barCode = null;
            }

            this.resetVariables();
        }

        promptUseDisplayNameForBarcode(): angular.IPromise<any> {
            return this.modalService
                .confirm("LABEL_USE_DISPLAY_NAME_AS_BARCODE",
                    Meevo.Components.Modal.ModalTranslationModes.Translate,
                    false)
                .then(() => this.model.barCode = this.model.displayName);
        }

        /**
         * Model review on response
         */
        public sectionModelRetrieved(): void {
            if (!this.model) return;

            if (this.model.isBuyGet && this.model.discountTypeEnum !== DiscountTypeEnum.BuyGet) {
                this.model.discountTypeEnumGet = this.model.discountTypeEnum;
            }

            if (this.model.services) {
                this.model.serviceIds = _(this.model.services).map(service => service.id);
            }
            if (this.model.productVariants) {
                this.model.productVariantIds = _(this.model.productVariants).map(variant => variant.id);
            }
            if (this.model.packageTypes) {
                this.model.packageTypeIds = _(this.model.packageTypes).map(packageType => packageType.id);
            }
            if (this.model.memberships) {
                this.model.membershipIds = _(this.model.memberships).map(membership => membership.id);
            }
            if (this.model.giftCardTypes) {
                this.model.giftCardTypeIds = _(this.model.giftCardTypes).map(giftCardType => giftCardType.id);
            }
            if (this.model.fees) {
                this.model.feeIds = _(this.model.fees).map(fee => fee.id);
            }
            if (this.model.buy_Services) {
                this.model.buy_ServiceIds = _(this.model.buy_Services).map(service => service.id);
            }
            if (this.model.buy_ProductVariants) {
                this.model.buy_ProductVariantIds = _(this.model.buy_ProductVariants).map(variant => variant.id);
            }
            if (this.model.buy_Memberships) {
                this.model.buy_MembershipIds = _(this.model.buy_Memberships).map(membership => membership.id);
            }
            if (this.model.buy_PackageTypes) {
                this.model.buy_PackageTypeIds = _(this.model.buy_PackageTypes).map(packageType => packageType.id);
            }
            if (this.model.buy_GiftCardTypes) {
                this.model.buy_GiftCardTypeIds = _(this.model.buy_GiftCardTypes).map(giftCardType => giftCardType.id);
            }

            if (this.model.isBuyGet) {
                this.model.requiredQuantity = 0;
                if (this.model.buy_Quantity <= 0) {
                    this.model.buy_Quantity = 1; // new minimum value is 1
                }
                if (this.model.get_Quantity <= 0) {
                    this.model.get_Quantity = 1; // new minimum value is 1
                }
            } else {
                this.model.buy_Quantity = 0;
                this.model.get_Quantity = 0;
                if (this.model.requiredQuantity <= 0) {
                    this.model.requiredQuantity = 1; // new minimum value is 1
                }
            }

            this.isAmountInPercents = this.model.discountTypeEnum === DiscountTypeEnum.PercentOff;
        }

        private resetVariables(): void {
            // reset unused variables(variables, that are hidden via ng-if)
            this.resetMover(<IMoverFields>{
                entityType: 'discountEntityTypeEnum',
                entityGranularityType: 'discountEntityGranularityTypeEnum',
                manufacturer: 'discountManufacturer_TId',
                packageTypes: 'packageTypes',
                productVariants: 'productVariants',
                services: 'services',
                memberships: 'memberships',
                giftCardTypes: 'giftCardTypes',
                fees: 'fees'
            });

            // check if we are using "Buy One/Get One" functionality
            if (this.model.isBuyGet) {
                this.resetMover(<IMoverFields>{
                    entityType: 'buy_EntityTypeEnum',
                    entityGranularityType: 'buy_EntityGranularityTypeEnum',
                    manufacturer: 'buy_Manufacturer_TId',
                    packageTypes: 'buy_PackageTypes',
                    productVariants: 'buy_ProductVariants',
                    services: 'buy_Services',
                    memberships: 'buy_Memberships',
                    giftCardTypes: 'buy_GiftCardTypes'
                });

                // ensure that historical BOGOs will be automatically applied until Product Owners change their minds
                if (this.model.isClientHistoryDependent) {
                    this.model.isAutoApply = true;
                }
            } else {
                delete this.model.buy_Amount;
                delete this.model.buy_Quantity;
                delete this.model.get_Quantity;
                delete this.model.isClientHistoryDependent;
                delete this.model.buy_EntityGranularityTypeEnum;
                delete this.model.buy_EntityTypeEnum;
                this.model.buy_Services = [];
                this.model.buy_ProductVariants = [];
                this.model.buy_PackageTypes = [];
                this.model.buy_Memberships = [];
                this.model.buy_GiftCardTypes = [];
            }
        }

        /**
         * reset unused fields in items' mover
         * @param {IMoverFields} moverFields
         */
        private resetMover(moverFields: IMoverFields): void {
            if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.ProductService
                || this.model[moverFields.entityGranularityType] === DiscountEntityGranularityTypeEnum.All) {
                this.model[moverFields.services] = [];
                this.model[moverFields.productVariants] = [];
                this.model[moverFields.packageTypes] = [];
                this.model[moverFields.memberships] = [];
                this.model[moverFields.giftCardTypes] = [];
            } else if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.Service || this.model[moverFields.entityType] === DiscountEntityTypeEnum.RebookedAppointments) {
                this.model[moverFields.productVariants] = [];
                this.model[moverFields.packageTypes] = [];
                this.model[moverFields.memberships] = [];
                this.model[moverFields.giftCardTypes] = [];
            } else if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.Product) {
                this.model[moverFields.services] = [];
                this.model[moverFields.packageTypes] = [];
                this.model[moverFields.memberships] = [];
                this.model[moverFields.giftCardTypes] = [];
            } else if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.Package) {
                this.model[moverFields.services] = [];
                this.model[moverFields.productVariants] = [];
                this.model[moverFields.memberships] = [];
                this.model[moverFields.giftCardTypes] = [];
            } else if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.Membership) {
                this.model[moverFields.services] = [];
                this.model[moverFields.productVariants] = [];
                this.model[moverFields.packageTypes] = [];
                this.model[moverFields.giftCardTypes] = [];
            } else if (this.model[moverFields.entityType] === DiscountEntityTypeEnum.GiftCard) {
                this.model[moverFields.services] = [];
                this.model[moverFields.productVariants] = [];
                this.model[moverFields.packageTypes] = [];
                this.model[moverFields.memberships] = []; 
            }

            if (this.model[moverFields.entityType] !== DiscountEntityTypeEnum.Product) {
                delete this.model[moverFields.manufacturer];
            }
        }

        /**
         * "Limit discount usage" checkbox changed
         * */
        public checkRedeemableLimit(): void {
            if (this.model.isRedeemableLimitApplicable) {
                if (typeof this.model.redeemableLimit === 'undefined' || this.model.redeemableLimit === null) {
                    this.model.redeemableLimit = 1;
                }
                if (typeof this.model.discountRedeemableLimitPerTypeEnum === 'undefined' || this.model.discountRedeemableLimitPerTypeEnum === null) {
                    this.model.discountRedeemableLimitPerTypeEnum = Meevo.Model.DiscountRedeemableLimitPerTypeEnum.Transaction;
                }
                if (typeof this.model.discountRedeemableLimitPerMonth === 'undefined'
                    || this.model.discountRedeemableLimitPerMonth === null) {
                    this.model.discountRedeemableLimitPerMonth = 1;
                }
            } else {
                this.model.redeemableLimit = null;
                this.model.discountRedeemableLimitPerMonth = null;
                this.model.discountRedeemableLimitPerTypeEnum = null;
            }
        }

        public serviceChanged(): void {
            var filterServices = _.pluck(this.model.services, "id");
            this.employeeFilterCriteria = { showEmployeesOnly: true, serviceIdList: filterServices };
        }

        public openProductFilter(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/discounts/sectionViews/productFilterModal.template.html',
                controller: 'meevo.plugins.discounts.ProductFilterModalController',
                controllerAs: '$ctrl',
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    productFilter: this.productFilter
                },
            };

            this.modalService
                .showCustom(options)
                .then((filter: IProductFilter) => {
                    this.productFilter = filter;
                    this.productCriteria['ManufacturerIds'] = this.productFilter.manufacturers.map(manufacturer => manufacturer.id)
                    this.productCriteria['ProductCategoryIds'] = this.productFilter.productCategories.map(category => category.id)
                });
        }

        public openServiceFilter(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/discounts/sectionViews/serviceFilterModal.template.html',
                controller: 'meevo.plugins.discounts.ServiceFilterModalController',
                controllerAs: '$ctrl',
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    serviceFilter: this.serviceFilter
                },
            };

            this.modalService
                .showCustom(options)
                .then((filter: IServiceFilter) => {
                    this.serviceFilter = filter;
                    this.serviceCriteria['ServiceCategoryIds'] = this.serviceFilter.serviceCategories.map(category => category.id)
                });
        }

        get discountEntityTypeEnum(): any {
            return DiscountEntityTypeEnum;
        }

        get discountEntityGranTypeEnum(): any {
            return DiscountEntityGranularityTypeEnum;
        }

        get discountTypeEnum(): any {
            return DiscountTypeEnum;
        }

        get discountBuyGetTypeEnum(): any {
            return DiscountBuyGetTypeEnum;
        }

        get basedOnEnum() {
            return DiscountBasedOnEnum;
        }

        public get hasProductFilter(): boolean {
            return !!this.productCriteria.ManufacturerIds.length || !!this.productCriteria.ProductCategoryIds.length
        }

        public get hasServiceFilter(): boolean {
            return !!this.serviceFilter.serviceCategories.length
        }

        public canModifyIsAllowRedeemBuyGet(): boolean {
            return this.model && this.model.isBuyGet && this.model.bogoBasedOnTypeEnum === DiscountBasedOnEnum.Quantity;
        }
    }
}
